import isEmpty from './isEmpty.util';

const FIRST_VALUE_INDEX = 0;

const getFirstArrayValueUtil = <T = any>(values: T[]): T | null => (!isEmpty(values) ? values[FIRST_VALUE_INDEX] : null);

export default getFirstArrayValueUtil;
